import React from 'react';

const ProfileForm = ({
  formData,
  setFormData,
  activeTab,
  setActiveTab,
  onCancel,
  onSubmit
}) => {
  const tabLabels = {
    personal: 'Личные данные',
    contacts: 'Контакты',
    documents: 'Документы',
    membership: 'Членство'
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const nestedFields = name.split('.');
    if (nestedFields.length > 1) {
      setFormData(prev => ({
        ...prev,
        [nestedFields[0]]: {
          ...prev[nestedFields[0]],
          [nestedFields[1]]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const renderPersonalTab = () => (
      <div className="form-content">
        <div className="form-row">
          <FormField
              label="Имя"
              name="firstName"
              value={formData.firstName || ''}
              onChange={handleChange}
          />
          <FormField
              label="Фамилия"
              name="lastName"
              value={formData.lastName || ''}
              onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <FormField
              label="Отчество"
              name="patronymic"
              value={formData.patronymic || ''}
              onChange={handleChange}
          />
          <FormField
              label="Дата рождения"
              name="birthDate"
              type="date"
              value={formData.birthDate || ''}
              onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <FormField
              label="Пол"
              name="gender"
              type="select"
              value={formData.gender || ''}
              onChange={handleChange}
              options={[
                { value: '', label: 'Выберите пол' },
                { value: 'Мужской', label: 'Мужской' },
                { value: 'Женский', label: 'Женский' },
              ]}
          />
          <FormField
              label="Место рождения"
              name="birthPlace"
              value={formData.birthPlace || ''}
              onChange={handleChange}
          />
          <FormField
              label="Национальность"
              name="nationality"
              value={formData.nationality || ''}
              onChange={handleChange}
          />
        </div>
      </div>
  );

  const renderContactsTab = () => (
      <div className="form-content">
        <div className="form-row">
          <FormField
              label="Email"
              name="email"
              type="email"
              value={formData.email || ''}
              onChange={handleChange}
          />
          <FormField
              label="Телефон"
              name="phoneNumber"
              type="tel"
              value={formData.phoneNumber || ''}
              onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <FormField
              label="Адрес"
              name="address"
              value={formData.address || ''}
              onChange={handleChange}
          />
          <FormField
              label="Соцсети"
              name="socialMedia"
              value={formData.socialMedia || ''}
              onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <FormField
              label="Адрес регистрации"
              name="registrationAddress"
              value={formData.registrationAddress || ''}
              onChange={handleChange}
          />
        </div>
      </div>
  );

  const renderDocumentsTab = () => (
      <div className="form-content">
        <div className="form-row">
          <FormField
              label="Серия паспорта"
              name="passportSeries"
              value={formData.passportSeries || ''}
              onChange={handleChange}
          />
          <FormField
              label="Номер паспорта"
              name="passportNumber"
              value={formData.passportNumber || ''}
              onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <FormField
              label="Кем выдан"
              name="passportIssuedBy"
              value={formData.passportIssuedBy || ''}
              onChange={handleChange}
          />
          <FormField
              label="Дата выдачи"
              name="passportIssueDate"
              type="date"
              value={formData.passportIssueDate || ''}
              onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <FormField
              label="Образование"
              name="education"
              type="select"
              value={formData.education || ''}
              onChange={handleChange}
              options={[
                {value: '', label: 'Выберите образование'},
                {value: 'Незаконченное среднее', label: 'Незаконченное среднее'},
                {value: 'Среднее', label: 'Среднее'},
                {value: 'Высшее', label: 'Высшее'},
                {value: 'Аспирантура', label: 'Аспирантура'},
                {value: 'Магистратура', label: 'Магистратура'},
              ]}
          />
        </div>
      </div>
  );

  const renderMembershipTab = () => (
      <div className="form-content">
        <div className="form-row">
          <FormField
              label="Членство в других организациях"
              name="memberships"
              value={formData.memberships || ''}
              onChange={handleChange}
              placeholder="Введите названия организаций"
          />
        </div>

        <div className="form-row">
          <FormField
              label="Мотивация для вступления"
              name="motivation"
              type="textarea"
              value={formData.motivation || ''}
              onChange={handleChange}
              rows={4}
          />
        </div>

        <div className="form-row">
          <FormField
              label="ФИО родителя"
              name="parentFullName"
              value={formData.parentFullName || ''}
              onChange={handleChange}
          />
          <FormField
              label="Телефон родителя"
              name="parentPhone"
              value={formData.parentPhone || ''}
              onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <FormField
              label="Email родителя"
              name="parentEmail"
              type="email"
              value={formData.parentEmail || ''}
              onChange={handleChange}
          />
        </div>
      </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'personal':
        return renderPersonalTab();
      case 'contacts':
        return renderContactsTab();
      case 'documents':
        return renderDocumentsTab();
      case 'membership':
        return renderMembershipTab();
      default:
        return null;
    }
  };

  return (
      <form
          className="profile-form"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
      >
        <div className="form-tabs">
          {Object.keys(tabLabels).map(tab => (
              <button
                  key={tab}
                  type="button"
                  className={`tab ${activeTab === tab ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab)}
              >
                {tabLabels[tab]}
              </button>
          ))}
        </div>

        {renderTabContent()}

        <div className="form-actions">
          <button type="submit" className="save-btn">
            Сохранить изменения
          </button>
          <button type="button" className="cancel-btn" onClick={onCancel}>
            Отменить
          </button>
        </div>
      </form>
  );
};

const FormField = ({
  label,
  name,
  value,
  type = 'text',
  onChange,
  options = [],
  rows = 1,
  placeholder = ''
}) => {
  if (type === 'select') {
    return (
        <div className="form-field">
          <label>{label}</label>
          <select
              name={name}
              value={value}
              onChange={onChange}
              className="form-input"
          >
            {options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
            ))}
          </select>
        </div>
    );
  }

  if (type === 'textarea') {
    return (
        <div className="form-field">
          <label>{label}</label>
          <textarea
              name={name}
              value={value}
              onChange={onChange}
              className="form-input"
              rows={rows}
              placeholder={placeholder}
          />
        </div>
    );
  }

  return (
      <div className="form-field">
        <label>{label}</label>
        <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            className="form-input"
            placeholder={placeholder}
        />
      </div>
  );
};

export default ProfileForm;